export function initBilling() {
	// ── Billing: mirror the delivery address into billing when "Same as delivery" is ticked ──
	// Copies from the hidden shipping inputs (rendered by form-checkout.php) so the billing
	// fields are actually populated, then collapses them. Required is dropped while collapsed
	// because a display:none required field blocks submit (can't be focused for validation).
	(function initBillingSameAsDelivery() {
		const toggle = document.querySelector('.js-billing-same');
		const fields = document.querySelector('.js-billing-fields');
		if (!toggle || !fields) {
			return;
		}
		const $ = window.jQuery;
		const keys = ['first_name', 'last_name', 'country', 'address_1', 'address_2', 'city', 'state', 'postcode', 'phone'];
		const copyShippingToBilling = function () {
			keys.forEach(function (k) {
				const src = document.getElementById('shipping_' + k);
				const dest = document.getElementById('billing_' + k);
				if (!src || !dest) {
					return;
				}
				dest.value = src.value;
				if ($ && dest.tagName === 'SELECT') {
					$(dest).trigger('change');
				} else {
					dest.dispatchEvent(new Event('change', { bubbles: true }));
				}
			});
		};
		const sync = function () {
			const collapsed = toggle.checked;
			if (collapsed) {
				copyShippingToBilling();
			}
			fields.hidden = collapsed;
			fields.querySelectorAll('input, select, textarea').forEach(function (el) {
				if (collapsed) {
					if (el.required) {
						el.dataset.msfRequired = '1';
						el.required = false;
					}
				} else if (el.dataset.msfRequired) {
					el.required = true;
					delete el.dataset.msfRequired;
				}
			});
		};
		toggle.addEventListener('change', sync);
		sync();
	})();
}
